import {Component} from 'react';
import Brand from './Brand';

export default class JournalErrorBoundary extends Component {
  state={failed:false};
  static getDerivedStateFromError(){return {failed:true};}
  render(){
    if(!this.state.failed)return this.props.children;
    return <main className="tl-load-failure"><Brand/><h1>This page couldn’t finish loading.</h1><p role="alert">Your saved journal has not been removed. If you were editing, your latest changes may not have saved.</p><div><button className="tl-btn tl-btn-primary" onClick={()=>window.location.reload()}>Reload TradeLog</button><a className="tl-btn" href="/support">Contact support</a><a className="tl-btn" href="/account">Membership & backup</a></div></main>;
  }
}
